import { Injectable } from "@angular/core";
import { HttpClient, HttpEventType, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { Subject } from 'rxjs/Subject';

@Injectable({
  providedIn: "root"
})
export class AssetUploadService {
  baseUrl = environment.baseUrl;

  fileUploadUrl = this.baseUrl + "fileUpload";
  importFileAndCreateTempTableUrl = this.baseUrl + "importAssetFile";
  importAssetDetailUrl = this.baseUrl + "importAssetDetail";
  insertAssetUploadMappingDataUrl = this.baseUrl + "insertAssetUploadData";
  getAssetUploadMappingDataUrl = this.baseUrl + "assetUploadMapping";

  getCategoryItemsByCategoryIdUrl =
    this.baseUrl + "getCategoryItemsByCategoryId";

  getDistinctValuesForInnerMappingUrl =
    this.baseUrl + "getDistinctValuesForInnerMapping";

  getKeyCodeValuesByKeyCodeUrl = this.baseUrl + "getKeyCodeValuesByKeyCode";

  removeAssetUploadUrl = this.baseUrl + "removeAssetUpload/";

  addAssetUploadExcludeDataUrl = this.baseUrl + "addAssetUploadExcludeData";

  restoreImportedAssetDatailsUrl = this.baseUrl + "restoreImportedAssetDatails";

  getAssetUploadExcludeDataUrl = this.baseUrl + "getAssetUploadExcludeData";

  deleteAssetUploadExclusionRecordUrl =
    this.baseUrl + "deleteAssetUploadExclusionRecord";

  addLocationDetailsUrl =
    this.baseUrl + "addLocationDetails";

  getAssetUploadHistoryUrl = this.baseUrl + "getAssetUploadHistory";
  getLocationByCustomerUrl = this.baseUrl + "getLocationByCustomer/";

  uploadSimplifiedAssetDataUrl = this.baseUrl + "uploadSimplifiedAssetData";

  constructor(private http: HttpClient) { }

  fileUpload(data): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);
    return this.http.post(this.fileUploadUrl, data, { headers: reqHeader });
  }

  importFileAndCreateTempTable(tempTableRequestData): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);
    return this.http.post(
      this.importFileAndCreateTempTableUrl,
      tempTableRequestData,
      {
        headers: reqHeader
      }
    );
  }

  importAssetDetail(
    intCustomerId,
    strTempTableName,
    arrAllSheetColumns,
    arrMappedSheetColumns,
    isUpdateVehicleStatusCode,
    intVehicleStatusCodeWhenAssetNotOnInputFile,
    UseLastEightDigit
  ): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };

    var importAssetDetailRequestData = {
      intCustomerId: intCustomerId,
      strTempTableName: strTempTableName,
      arrMappedSheetColumns: arrMappedSheetColumns,
      arrAllSheetColumns: arrAllSheetColumns,
      isUpdateVehicleStatusCode: isUpdateVehicleStatusCode,
      intVehicleStatusCodeWhenAssetNotOnInputFile: intVehicleStatusCodeWhenAssetNotOnInputFile,
      isUseLastEightDigit: UseLastEightDigit,
      customerKey: sessionStorage.getItem("legacyCustomerKeyId"),
      companyName: sessionStorage.getItem("companyName")
    };
    var reqHeader = new HttpHeaders(headerData);
    return this.http.post(
      this.importAssetDetailUrl,
      importAssetDetailRequestData,
      {
        headers: reqHeader
      }
    );
  }

  insertAssetUploadMappingData(
    arrInsertAssetUploadMappingData
  ): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);

    var arrMappedSheetColumns = {
      arrMappedSheetColumns: [arrInsertAssetUploadMappingData]
    };
    return this.http.post(
      this.insertAssetUploadMappingDataUrl,
      arrMappedSheetColumns,
      {
        headers: reqHeader
      }
    );
  }

  getAssetUploadMappingData(fleetCustomerId): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);
    var req = {
      customerId: fleetCustomerId
    };

    console.log("fleetCustomerId===" + fleetCustomerId);
    return this.http.post(this.getAssetUploadMappingDataUrl, req, {
      headers: reqHeader
    });
  }

  getCategoryItemsByCategoryId(categoryId): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);
    var reqData = {
      category_Id: categoryId
    };

    return this.http.post(this.getCategoryItemsByCategoryIdUrl, reqData, {
      headers: reqHeader
    });
  }

  getKeyCodeValuesByKeyCode(vmrsKeyCode): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);
    var reqData = {
      vmrsKeyCode: vmrsKeyCode
    };

    return this.http.post(this.getKeyCodeValuesByKeyCodeUrl, reqData, {
      headers: reqHeader
    });
  }

  getDistinctValuesForInnerMapping(arrReqData): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);

    return this.http.post(
      this.getDistinctValuesForInnerMappingUrl,
      arrReqData,
      {
        headers: reqHeader
      }
    );
  }

  removeAssetUpload(intMapId): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);

    return this.http.get(this.removeAssetUploadUrl + intMapId, {
      headers: reqHeader
    });
  }

  addAssetUploadExcludeData(arrReqData): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);

    return this.http.post(this.addAssetUploadExcludeDataUrl, arrReqData, {
      headers: reqHeader
    });
  }

  getAssetUploadExcludeData(arrReqData): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);

    return this.http.post(this.getAssetUploadExcludeDataUrl, arrReqData, {
      headers: reqHeader
    });
  }

  deleteAssetUploadExclusionRecord(arrReqData): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);

    return this.http.post(
      this.deleteAssetUploadExclusionRecordUrl,
      arrReqData,
      {
        headers: reqHeader
      }
    );
  }

  restoreAssetData(arrReqData): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };

    var reqHeader = new HttpHeaders(headerData);

    return this.http.post(this.restoreImportedAssetDatailsUrl, arrReqData, {
      headers: reqHeader
    });
  }
  addLocationDetails(arrReqData): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);

    return this.http.post(this.addLocationDetailsUrl, arrReqData, {
      headers: reqHeader
    });

  }
  getAssetUploadHistory(arrReqData): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };

    var reqHeader = new HttpHeaders(headerData);

    return this.http.post(this.getAssetUploadHistoryUrl, arrReqData, {
      headers: reqHeader
    });
  }


  getLocationByCustomer(intCustomerId) {
    return this.http.get(this.getLocationByCustomerUrl + intCustomerId);
  }

  uploadSimplifiedAssetData(arrReqData): Observable<any> {
    var headerData = {
      token: "TTNFleet2018"
    };

    var reqHeader = new HttpHeaders(headerData);

    return this.http.post(this.uploadSimplifiedAssetDataUrl, arrReqData, {
      headers: reqHeader
    });
  }




  // Observable string sources
  private componentMethodCallSource = new Subject<any>();

  // Observable string streams
  componentMethodCalled$ = this.componentMethodCallSource.asObservable();

  // Service message commands
  callComponentMethod() {
    this.componentMethodCallSource.next(123);
  }






}
